import script from "./Location.vue?vue&type=script&lang=ts&setup=true"
export * from "./Location.vue?vue&type=script&lang=ts&setup=true"

import "./Location.vue?vue&type=style&index=0&id=63f5b3f0&scoped=true&lang=less"
import "./Location.vue?vue&type=style&index=1&id=63f5b3f0&lang=less"
import "./Location.vue?vue&type=style&index=2&id=63f5b3f0&lang=less"

import exportComponent from "D:\\work\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63f5b3f0"]])

export default __exports__